import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Button, LbInput, LbSelect, InputAdornment } from '@infoods/lifebase-ui';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import classes from './FiltersRow.module.scss';
import { AgeInput } from '../../../../../shared/components/form-components/AgeInput/AgeInput';
import { genderOptionsWithAll } from '../../../../../shared/constants/user-info/gender';
import { addAllOption, transformToOptions } from '../../../../../shared/utils/arrayUtils';
import { useAutoSubmitForm } from '../../../../../shared/hooks/useAutoSubmitForm';
import { LeaderboardFilterValues, leaderboardStore } from '../../../../../challenges';

const FiltersRow = observer(() => {
  const { filterMethods, challengeInfo } = leaderboardStore;
  const { applyFilters } = filterMethods;

  const { divisions } = challengeInfo || {};

  const { control, reset, watch, handleSubmit } = useForm<LeaderboardFilterValues>();

  const onSubmit = handleSubmit((data: LeaderboardFilterValues) => {
    applyFilters(data);
  });

  useAutoSubmitForm(onSubmit, watch, ['nickname', 'ageMin', 'ageMax']);

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  const handleReset = () => {
    reset();
  };

  const divisionOptions = transformToOptions({
    list: divisions || [],
    valueKey: 'id',
    labelKey: 'name',
  });

  return (
    <div className={classes.filterRow}>
      <LbInput
        {...inputGeneralProps}
        name="nickname"
        placeholder="Name"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchRoundedIcon fontSize="large" color="tertiary" />
            </InputAdornment>
          ),
        }}
      />
      <LbSelect
        {...inputGeneralProps}
        label="Gender"
        name="gender"
        options={genderOptionsWithAll}
        displayEmpty
      />
      <AgeInput
        {...inputGeneralProps}
        startFieldProps={{ name: 'ageMin' }}
        endFieldProps={{ name: 'ageMax' }}
      />
      {divisionOptions.length ? (
        <LbSelect
          {...inputGeneralProps}
          label="Division"
          name="divisionId"
          options={addAllOption(divisionOptions)}
          displayEmpty
        />
      ) : null}
      <Button
        variant="outlined"
        className={classes.clearAllButton}
        size="small"
        type="reset"
        onClick={handleReset}
      >
        Clear All
      </Button>
    </div>
  );
});

export { FiltersRow };
